import type { QueryKey } from '@tanstack/react-query';

import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';
import type { VendoredDependencyPathsResponse } from '../../../../shared/vendoredDependencies';

function fetchVendoredDependencyPaths(locator: string) {
  return get<VendoredDependencyPathsResponse>(`/api/revisions/${nuc(locator)}/vendoredDependencies/paths`);
}

const getQueryKey = (locator: string): QueryKey => ['revisions', locator, 'vendoredDependencies', 'paths'];

/**
 * Hook to fetch vendored dependency paths.
 */
export default function useVendoredDependencyPaths(locator: string) {
  return useQuery({
    queryFn: () => fetchVendoredDependencyPaths(locator),
    queryKey: getQueryKey(locator),
  });
}
